import { Modal } from 'bootstrap';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { DisplayListPagination } from '../../../components/TapUi';
import TapHelper from '../../../services/TapHelper';
import DateService from '../../../services/DateService';

function InwardHistoryModal({}, ref) {

    const modalId                   =   uuid();
    const modalElementRef           =   useRef();
    const modalRef                  =   useRef();

    const access_token              =   useSelector(state => state.auth.access_token);

    const listingUrl                =   INVENTORY_API_BASE_URL_2 + '/item_inward_history';

    const [loading, setLoading]     =   useState(false);
    const [listing, setListing]     =   useState([]);
    const [listingMeta, setListingMeta] =   useState(null);
    const [inWard, setInWard]       =   useState({
        item_name       :   '',
        item_code       :   '',
        manufacturer    :   '',
        warehouse_name  :   '' 
    });

    useImperativeHandle(ref, () => ({
        initModalHandler: (item, warehouse) => { 
            openModal();
            if(item && warehouse) {
                setInWard({
                    item_name       :   item.name,
                    item_code       :   item.item_code,
                    manufacturer    :   item.manufacturer?.name,
                    warehouse_name  :   warehouse.name,
                });
                listingData(item.id, warehouse.id);
            }
        }
    }));

    useEffect(() => {
        modalElementRef.current             =   document.getElementById(modalId);
        modalRef.current                    =   new Modal(modalElementRef.current, {keyboard: false, backdrop :false});
        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);
        
    const openModal                 =   () => {
        if (modalRef.current) {
            modalRef.current.show();
        }
    }
    const closeModal                =   () => {
        modalRef.current.hide();
    }

    const listingData               =   async(item_id, warehouse_id, page=1)  =>  {
        
        setLoading(pre => !pre);

        const res                   =   await HttpAPICall.withAthorization("GET",  `${listingUrl}/${item_id}`, access_token, {warehouse_id, page}, {});

        setLoading(pre => !pre);

        if(res.data) {
            const respData              =   res.data;
            
            setListingMeta({
                from            :   respData.from,
                to              :   respData.to,
                total           :   respData.total,
                last_page       :   respData.last_page,
                per_page        :   respData.per_page,
                current_page    :   respData.current_page
            });
            setListing(respData.data);
        }else {
            setListing([]);
        }

        
    }

  return (
    <>
        <div className="modal fade" id={modalId} ref={modalElementRef} tabIndex="-1">
            <div className="modal-dialog modal-xl modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Inward History</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <ul style={{listStyleType : 'none'}} className='ps-0'>
                            <li ><b>Item Name</b>: {inWard.item_name}</li>
                            <li className='mt-2'><b>Item Code</b>: {inWard.item_code}</li>
                            <li className='mt-2'><b>Manufacturer Name</b>: {inWard.manufacturer}</li>
                            <li className='mt-2'><b>Inward Warehouse</b>: {inWard.warehouse_name}</li>
                        </ul>
                        <table className="table table-bordered table-sm align-middle bg-white my-2">
                            <thead className="align-middle table-secondary">
                                <tr className='text-start'>
                                <th className="text-center" style={{ width: "5%" }}>S.No</th>
                                <th className='text-center' style={{ width: "10%" }}>Transaction ID</th>
                                <th className='text-center' style={{ width: "11%" }}>Transaction Date</th>
                                <th className='text-center' style={{ width: "10%" }}>Transaction Type</th>
                                <th className='text-center' scope="col" style={{ width: "10%" }}>Batch No./Expiry Date</th>
                                <th scope="col" className='text-center' style={{ width: "15%" }}>Received From</th>
                                <th scope="col" className='text-center' style={{ width: "8%" }}>Qty</th>
                                <th scope="col" className='text-center' style={{ width: "8%" }}>Unit Rate</th>
                                <th scope="col" className='text-center' style={{ width: "8%" }}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    loading 
                                    ? <tr className='text-center'><td colSpan={9}><Loader/></td></tr>
                                    :
                                    listing.length > 0 
                                    ? listing.map((d, i) => (
                                        <tr key={i}>
                                            <td className='text-center'>{listingMeta?.from + i}</td>
                                            <td className='text-center'>{d.transaction_id}</td>
                                            <td className='text-center'>{DateService.dateFormat(d.transaction_date)}</td>
                                            <td className='text-center'>{d.transaction_type}</td>
                                            <td>
                                                {d.batch_number ? `BN : ${d.batch_number}` : '' } <br />
                                                {d.expiry_date ? `ED : ${d.expiry_date}` : '' }
                                            </td>
                                            <td className='text-center'>{d.vendor_name || '-'}</td>
                                            <td className='text-end'>{d.qty}</td>
                                            <td className='text-end'>{d.rate}</td>
                                            <td className='text-end'>{ d?.amount &&  TapHelper.numberFormatter(d.amount, 2)}</td>
                                        </tr>
                                    ))
                                    : <tr className='text-center'><td colSpan={9}>No Record Found</td></tr>
                                }
                            </tbody>
                        </table>
                        <DisplayListPagination meta={listingMeta} onPageChange={(e) => listingData(e.selected + 1)} />
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={closeModal}>Close</button>
                    </div>

                </div>
            </div>
        </div>
    </>
  )
}

export default forwardRef(InwardHistoryModal)